import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <>
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col lg="8" md="10">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <h3 className="text-center mb-4">Política de Privacidade</h3>

                <p>
                  Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações ao utilizar o nosso sistema.
                </p>

                <h5>1. Coleta de Informações</h5>
                <p>
                  Coletamos informações pessoais como nome, e-mail e credenciais de login para autenticação no sistema. Também podemos coletar dados de uso e interações com as funcionalidades do sistema para fins de melhoria contínua.
                </p>

                <h5>2. Uso das Informações</h5>
                <p>
                  As informações coletadas são utilizadas exclusivamente para:
                  <ul>
                    <li>Permitir o acesso seguro ao sistema</li>
                    <li>Gerenciar dispositivos e mensagens via WhatsApp</li>
                    <li>Personalizar a experiência do usuário</li>
                    <li>Melhorar a performance e segurança da aplicação</li>
                  </ul>
                </p>

                <h5>3. Compartilhamento</h5>
                <p>
                  Não compartilhamos suas informações com terceiros, exceto quando exigido por lei ou por ordem judicial.
                </p>

                <h5>4. Armazenamento e Segurança</h5>
                <p>
                  Seus dados são armazenados com segurança em nossos servidores e protegidos por medidas técnicas e administrativas contra acessos não autorizados.
                </p>

                <h5>5. Seus Direitos</h5>
                <p>
                  Você pode solicitar a atualização, correção ou exclusão de seus dados a qualquer momento, entrando em contato com nossa equipe de suporte.
                </p>

                <h5>6. Alterações nesta Política</h5>
                <p>
                  Reservamo-nos o direito de modificar esta política a qualquer momento. Notificações sobre alterações relevantes serão feitas diretamente no sistema.
                </p>

                <p className="mt-4 mb-0">
                  Ao utilizar nosso sistema, você concorda com os termos desta política.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
